import {
  GET_PATIENT_AGE,
  GET_ETHINCITY,
  GET_EXPOSURE_PREGNANCY,
  GET_SOURCE_DATA,
  GET_SPECIFY,
  GET_PREGNANCY_OOUTCOME,
  GET_DELEVERY,
  GET_BIRTH_TYPE,
  GET_CONTINUING,
  GET_FETAL_OUTCOME,
  ADD_CASE_PATIENT_PRAGNANCY,
  UPDATE_CASE_PATIENT_PRAGNANCY,
  ADD_CASE_PATIENT_INFO,
  UPDATE_CASE_PATIENT_INFO,
  UPDATE_CASE_PATIENT_CHAR,
  ADD_CASE_PATIENT_CHAR,
  ADD_CASE_PATIENT_MEDICAL,
  UPDATE_CASE_PATIENT_MEDICAL,
  ADD_CASE_PATIENT_DRUG,
  UPDATE_CASE_PATIENT_DRUG,
  ADD_CASE_PATIENT_LAB,
  UPDATE_CASE_PATIENT_LAB,
  ADD_CASE_PARENT_INFO,
  UPDATE_CASE_PARENT_INFO,
  ADD_CASE_PARENT_MEDICAL,
  UPDATE_CASE_PARENT_MEDICAL,
  ADD_CASE_PARENT_DRUG,
  UPDATE_CASE_PARENT_DRUG,
  ADD_CASE_PARENT_LAB,
  UPDATE_CASE_PARENT_LAB,
  GET_TESTRESULT,
} from '../../types'

const INITIAL_STATE = {
  allPatientAge: [],
  allEthincity: [],
  allExposurePregnacy: [],
  allSourceData: [],
  allSpecify: [],
  allPregnnacy: [],
  allDelevery: [],
  allBirthType: [],
  allContinuing: [],
  allFetalOut: [],
  allPragnancy: [],
  updatePragnancy: [],
  allPatientInfo: [],
  updatePatientInfo: [],
  allPatientChar: [],
  updatePatientChar: [],
  allPatientMedical: [],
  updatePatientMedical: [],
  allPatientDrug: [],
  updatePatientDrug: [],
  allPatientLabTest: [],
  updatePatientLabTest: [],
  allParentInfo: [],
  updateParentInfo: [],
  allParentMedical: [],
  updateParentMedical: [],
  allParentDrug: [],
  updateParentDrug: [],
  allParentLabTest: [],
  updateParentLabTest: [],
  allTestResult: [],
}
const patientReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    //MAIN
    case ADD_CASE_PATIENT_PRAGNANCY:
      return {
        ...state,
        allPragnancy: payload.data,
      }
    //MAIN END
    case GET_PATIENT_AGE:
      return {
        ...state,
        allPatientAge: payload.data,
      }
    case GET_ETHINCITY:
      return {
        ...state,
        allEthincity: payload.data,
      }
    case GET_EXPOSURE_PREGNANCY:
      return {
        ...state,
        allExposurePregnacy: payload.data,
      }
    case GET_SOURCE_DATA:
      return {
        ...state,
        allSourceData: payload.data,
      }
    case GET_SPECIFY:
      return {
        ...state,
        allSpecify: payload.data,
      }
    case GET_PREGNANCY_OOUTCOME:
      return {
        ...state,
        allPregnnacy: payload.data,
      }
    case GET_DELEVERY:
      return {
        ...state,
        allDelevery: payload.data,
      }
    case GET_BIRTH_TYPE:
      return {
        ...state,
        allBirthType: payload.data,
      }
    case GET_CONTINUING:
      return {
        ...state,
        allContinuing: payload.data,
      }
    case GET_FETAL_OUTCOME:
      return {
        ...state,
        allFetalOut: payload.data,
      }
    case UPDATE_CASE_PATIENT_PRAGNANCY:
      return {
        ...state,
        updatePragnancy: payload.data,
      }
    case ADD_CASE_PATIENT_INFO:
      return {
        ...state,
        allPatientInfo: payload.data,
      }
    case UPDATE_CASE_PATIENT_INFO:
      return {
        ...state,
        updatePatientInfo: payload.data,
      }
    case ADD_CASE_PATIENT_CHAR:
      return {
        ...state,
        allPatientChar: payload.data,
      }
    case UPDATE_CASE_PATIENT_CHAR:
      return {
        ...state,
        updatePatientChar: payload.data,
      }
    case ADD_CASE_PATIENT_MEDICAL:
      return {
        ...state,
        allPatientMedical: payload.data,
      }
    case UPDATE_CASE_PATIENT_MEDICAL:
      return {
        ...state,
        updatePatientMedical: payload.data,
      }
    case ADD_CASE_PATIENT_DRUG:
      return {
        ...state,
        allPatientDrug: payload.data,
      }
    case UPDATE_CASE_PATIENT_DRUG:
      return {
        ...state,
        updatePatientDrug: payload.data,
      }
    case ADD_CASE_PATIENT_LAB:
      return {
        ...state,
        allPatientLabTest: payload.data,
      }
    case UPDATE_CASE_PATIENT_LAB:
      return {
        ...state,
        updatePatientLabTest: payload.data,
      }
    case ADD_CASE_PARENT_INFO:
      return {
        ...state,
        allParentInfo: payload.data,
      }
    case UPDATE_CASE_PARENT_INFO:
      return {
        ...state,
        updateParentInfo: payload.data,
      }
    case ADD_CASE_PARENT_MEDICAL:
      return {
        ...state,
        allParentMedical: payload.data,
      }
    case UPDATE_CASE_PARENT_MEDICAL:
      return {
        ...state,
        updateParentMedical: payload.data,
      }
    case ADD_CASE_PARENT_DRUG:
      return {
        ...state,
        allParentDrug: payload.data,
      }
    case UPDATE_CASE_PARENT_DRUG:
      return {
        ...state,
        updateParentDrug: payload.data,
      }
    case ADD_CASE_PARENT_LAB:
      return {
        ...state,
        allParentLabTest: payload.data,
      }
    case UPDATE_CASE_PARENT_LAB:
      return {
        ...state,
        updateParentLabTest: payload.data,
      }
    case GET_TESTRESULT:
      return {
        ...state,
        allTestResult: payload.data,
      }
    default:
      return state
  }
}

export default patientReducer
